import React from "react";
import PropTypes from "prop-types";
import Rail from "web/react/components/rail/rail";
import LazyLoadImage from "web/react/components/lazy-load-image/lazy-load-image";
import styles from "./homepage-store-rail.css";

const StorePropType = PropTypes.shape({
    title: PropTypes.string,
    image_url: PropTypes.string,
    image_alt: PropTypes.string,
    url: PropTypes.string,
});

export function HomepageStoreItem({ store }) {
    return (
        <div className={styles.homepageStoreItem}>
            <a href={store.url}>
                <LazyLoadImage
                    className={styles.homepageStoreImg}
                    src={store.image_url}
                    alt={store.image_alt}
                />
            </a>
            <a className={styles.homepageStoreLink} href={store.url}>
                {store.title}
            </a>
        </div>
    );
}

HomepageStoreItem.propTypes = {
    store: StorePropType,
};

export function HomepageStoreRail({ stores }) {
    return (
        <div className={styles.homepageStoreWrap}>
            <Rail
                className={styles.homepageStoreRail}
                analyticsLabel={"homepage_store_rail"}
                title={""}
                smallRail={true}
            >
                {stores.map((store) => {
                    return <HomepageStoreItem key={store.url} store={store} />;
                })}
            </Rail>
        </div>
    );
}

HomepageStoreRail.propTypes = {
    stores: PropTypes.arrayOf(StorePropType).isRequired,
};

export default HomepageStoreRail;
